import { Link, LinkVariant } from '@ampcore/adel-react'
import React, { useRef, useState } from 'react'

import { AdvisorData } from '../../types/AdvisorData.type'

export type PersonalizedProspectDropdownProps = {
  className?: string
  advisorData?: AdvisorData | null
  testId?: string
}

export const PersonalizedProspectDropdown: React.FC<
  PersonalizedProspectDropdownProps
> = props => {
  const { className, advisorData, testId } = props
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  const handleOpenClick = () => {
    setIsOpen(true)
  }

  const handleBlur = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    timerRef.current = setTimeout(() => {
      setIsOpen(false)
    }, 1000)
  }

  const handleFocus = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
  }

  if (!advisorData) {
    return null
  }

  return (
    <nav
      id="personalized-sticky-advisor"
      className={`PersonalizedProspectDropdown ${className} ${
        isOpen ? 'is-open' : ''
      }`}
      data-testid={testId}
      onMouseEnter={handleFocus}
      onMouseLeave={handleBlur}
    >
      <button
        id="personalized-button"
        className="Button Button--primary Button--small"
        tabIndex={-1}
        onClick={handleOpenClick}
        data-testid={testId ? `${testId}-button` : undefined}
      >
        Contact {advisorData?.name ?? ''}
      </button>
      <ul className="PersonalizedProspectDropdown-list u-paddingLeft0">
        {advisorData?.url && (
          <li>
            <Link
              variant={LinkVariant.DEFAULT}
              url={advisorData?.url}
              name="Request consultation"
              testId={testId ? `${testId}-request-consultation` : undefined}
            />
          </li>
        )}
        {advisorData?.email && (
          <li>
            <Link
              variant={LinkVariant.DEFAULT}
              url={`mailto:${advisorData?.email}`}
              name={`Email ${advisorData?.name}`}
              testId={testId ? `${testId}-email` : undefined}
            />
          </li>
        )}
        {advisorData?.phonenumber && (
          <li>
            <Link
              variant={LinkVariant.DEFAULT}
              url={`tel:${advisorData?.phonenumber}`}
              name={`Call ${advisorData?.name}`}
              testId={testId ? `${testId}-tel` : undefined}
            />
          </li>
        )}
      </ul>
    </nav>
  )
}
